import { scaleProfile } from '../../engine/terrain/TerrainProfile';
import type { HollowSceneDef } from '../scenes/HollowScene';
import { GLOWMIRE, GLOWMIRE_TERRAIN } from './glowmire';

const RING = 2400;
const TUBE = 800;

/**
 * Halo: a donut-shaped hollow. Its tube is 1.6 km across and its ring 4.8 km across the
 * middle, so the ground wraps overhead as the tube's far wall and curves up and away along
 * the ring in both directions. There is no sun: it is lit by its own glowing marsh
 * (Glowmire's look, its land scaled to the tube).
 */
export const HALO: HollowSceneDef = {
  ...GLOWMIRE,
  id: 'halo',
  name: 'Halo',
  center: [-6.4e6, 5.3e6, 7.7e6],
  radius: RING,
  torus: { tube: TUBE },
  seed: 211,
  terrain: scaleProfile(GLOWMIRE_TERRAIN, TUBE / GLOWMIRE.radius, TUBE / GLOWMIRE.radius),
  air: null,
  clouds: null,
  // The outer equator, looking along the ring.
  spawn: { dir: [1, 0, 0], minHeight: 0.5, maxHeight: 25 },
  hints: [
    'A donut-shaped world. Overhead is the far side of the tube; along the ring the ground curves up and away.',
    'Keep walking along the ring and you come back where you started. V to fly.',
  ],
};
